import { TGetStockBalancesQuery } from './types';

export const normalizeFilterValue = (value: unknown) => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  if (Array.isArray(value) && value.length === 0) {
    return undefined;
  }

  return value;
};

export const applyFilterQuery = (
  currentQuery: TGetStockBalancesQuery,
  patch: Partial<TGetStockBalancesQuery>,
): TGetStockBalancesQuery => ({
  ...currentQuery,
  ...patch,
  page: 1,
});
